<div class="h-full min-h-0 overflow-y-auto scrollbar-transparent">
  <div class="flex flex-col gap-3 pb-2">
    <nav aria-label="Application status filters" class="shrink-0 flex flex-wrap gap-2 p-1">
      @for (filter of statusFilters; track filter.key) {
        <button
          type="button"
          class="rounded-lg px-3 py-1.5 text-sm font-medium cursor-pointer"
          [class]="statusFilterClass(filter.key)"
          (click)="selectStatus(filter.key)">
          {{ filter.label }}
        </button>
      }
    </nav>

    @if (loadingState() === 'loading') {
      <p class="text-sm text-secondary m-0 p-4">Loading applications…</p>
    } @else if (loadingState() === 'error') {
      <p class="text-sm text-red-600 m-0 p-4" role="alert">Failed to load applications.</p>
    } @else if ((applications() ?? []).length === 0) {
      <p class="text-sm text-secondary m-0 p-4">No applications for this filter.</p>
    } @else {
      <div class="data-table-wrapper w-full overflow-hidden">
        <table class="data-table min-w-full">
          <thead>
            <tr>
              <th scope="col" class="text-left">Brief</th>
              <th scope="col" class="text-left">Status</th>
              <th scope="col" class="text-left">Created</th>
              <th scope="col" class="text-left">Status updated</th>
            </tr>
          </thead>
          <tbody>
            @for (application of applications() ?? []; track application.id) {
              <tr
                class="cursor-pointer transition-all duration-300 hover:bg-zinc-50 dark:hover:bg-zinc-700/60"
                (click)="openApplication(application)">
                <td>
                  <p class="m-0 text-sm font-medium text-primary">{{ briefTitle(application) }}</p>
                  <p class="m-0 text-xs text-secondary">{{ briefSubtitle(application) }}</p>
                </td>
                <td>
                  <atom-application-status-badge
                    [applicationStatus]="application.applicationStatus" />
                </td>
                <td>
                  <p class="m-0 text-sm text-secondary">
                    {{ application.createdDate | date: 'dd MMM yy HH:mm' }}
                  </p>
                </td>
                <td>
                  <p class="m-0 text-sm text-secondary">
                    @if (application.applicationStatusModifiedDate) {
                      {{ application.applicationStatusModifiedDate | date: 'dd MMM yy HH:mm' }}
                    } @else {
                      —
                    }
                  </p>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>

<ins-creator-application-drawer
  #applicationDrawer
  (applicationUpdated)="onApplicationUpdated($event)" />
